<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="90%">
    <template v-slot:title>Itinerary Map Creator</template>
    <v-row>
      <v-col cols="3">
        <v-text-field
          label="Map Width"
          v-model="mapWidth"
          :outlined="outlinedInputs"
        />
        <v-text-field
          label="Map Height"
          v-model="mapHeight"
          :outlined="outlinedInputs"
        />
        <v-slider label="Zoom" min="0" max="20" v-model="zoom" />
        <v-select
          label="Map Type"
          v-model="mapType"
          :items="mapTypes"
          :outlined="outlinedInputs"
        ></v-select>
        <v-select
          label="Map Mode"
          v-model="mapMode"
          :items="mapModes"
          :outlined="outlinedInputs"
        ></v-select>
        <v-select
          label="Waypoints Source"
          v-model="selectedSupplierType"
          :items="supplierTypes"
          :outlined="outlinedInputs"
          @change="onWaypointsSourceChange"
        ></v-select>
        <simple-draggable-list v-model="waypoints" />
        <div class="d-flex align-center mt-3">
          <v-text-field
            placeholder="New Waypoint"
            :outlined="outlinedInputs"
            hide-details
            v-model="newWaypoint"
            class="mr-1"
            prepend-inner-icon="mdi-map-marker"
            dense
          ></v-text-field>
          <v-btn fab color="primary" @click="onAddNewWaypoint" small
            ><v-icon dark>mdi-plus</v-icon></v-btn
          >
        </div>
      </v-col>
      <v-col cols="9">
        <iframe
          :width="mapWidth"
          :height="mapHeight"
          style="border: 0"
          loading="lazy"
          allowfullscreen
          :src="mapURL"
        >
        </iframe>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn v-if="false" color="primary" @click="onGetURL">Get URL</v-btn>
    </template>
    <v-row>
      <v-col>
        <v-textarea v-model="htmlCode" :outlined="outlinedInputs"></v-textarea>
      </v-col>
    </v-row>
    <v-row v-if="false">
      {{ waypoints }}
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../shared/BasicDialog.vue";
import { ITINERARY_DELETE_MUTATION } from "../../../constants/graphql";
import SimpleDraggableList from "../shared/SimpleDraggableList.vue";
const IT_SUPPLIERS_INFO = gql`
  query itinerarySuppliersInfo($id: ID!) {
    itinerary(id: $id) {
      id
      items {
        edges {
          node {
            id
            orderNo
            serviceName
            supplier {
              id
              serviceType
              name
              destinationName
              geolocation
              address
            }
          }
        }
      }
    }
  }
`;
export default {
  name: "itinerary-map-creator-dialog",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    itineraryId: {
      type: String,
      default: () => "",
    },
  },

  components: { BasicDialog, SimpleDraggableList },

  data() {
    return {
      debug: false,
      apiKey: "AIzaSyAUJX8TrUz2compJ8ls308IG3v14x2UPLM",
      mapWidth: "100%",
      mapHeight: "100%",
      zoom: 6,
      mapType: "roadmap",
      mapTypes: ["roadmap", "satellite"],
      mapMode: "driving",
      mapModes: ["driving", "walking", "bicycling", "transit", "flying"],
      waypoints: [],
      newWaypoint: "",
      selectedSupplierType: "ACCOMMODATION",
      supplierTypes: [
        "ACCOMMODATION",
        "ACTIVITY",
        "TRANSPORT",
        "TRAVEL",
        "OTHER",
      ],
    };
  },

  computed: {
    mapURL() {
      //return "https://www.google.com/maps/@?api=1&map_action=map";
      const origin = this.waypoints[0];
      const destination = this.waypoints[this.waypoints.length - 1];

      const waypts =
        this.waypoints.length > 2
          ? `&waypoints=${this.waypoints.slice(1, -1).join("|")}`
          : "";
      return `https://www.google.com/maps/embed/v1/directions?key=${this.apiKey}&zoom=${this.zoom}&maptype=${this.mapType}&mode=${this.mapMode}&origin=${origin}&destination=${destination}${waypts}`;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    htmlCode() {
      return `<iframe width="${this.mapWidth}" height="${this.mapHeight}" style="border: 0" loading="lazy" allowfullscreen src="${this.mapURL}"></iframe>`;
    },
    itineraryWaypoints() {
      return this.itinerary
        ? this.itinerary.items.edges
            .filter(
              (e) =>
                e.node.supplier.serviceType == this.selectedSupplierType &&
                (e.node.supplier.address.toString() != "" ||
                  e.node.supplier.geolocation.toString() != "")
            )
            .map((e) =>
              e.node.supplier.geolocation.toString() != ""
                ? e.node.supplier.geolocation.toString()
                : e.node.supplier.address
                    .toString()
                    .replace(/(\r\n|\n|\r)/gm, ",")
            )
        : [];
    },
  },

  methods: {
    onAddNewWaypoint() {
      this.waypoints.push(this.newWaypoint);
      this.newWaypoint = "";
    },
    onGetURL() {
      console.log("getting url");
    },
    onWaypointsSourceChange() {
      this.waypoints = [...this.itineraryWaypoints];
    },
  },
  apollo: {
    itinerary: {
      query: IT_SUPPLIERS_INFO,
      variables() {
        return { id: this.itineraryId };
      },
      skip() {
        return this.itineraryId == "" || !this.show;
      },
      result() {
        this.waypoints = [...this.itineraryWaypoints];
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryMapCreatorDialog.vue